import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "user-info"
};
const _hoisted_2 = {
  class: "line"
};
const _hoisted_3 = {
  class: "line"
};
import { onMounted, onUnmounted, ref } from "vue";
import { useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import { httpGet } from "@/utils/http";
import { setUserToken } from "@/store/session";
import Clipboard from "clipboard";
import { showMessageError, showMessageOK } from "@/utils/dialog";
import { getRoute } from "@/store/system";
import { checkSession } from "@/store/cache";
export default {
  __name: 'LoginCallback',
  setup(__props) {
    const winHeight = ref(window.innerHeight);
    const loading = ref(true);
    const router = useRouter();
    const show = ref(false);
    const username = ref('');
    const password = ref('');
    const code = router.currentRoute.value.query.code;
    const action = router.currentRoute.value.query.action;
    if (code === "") {
      ElMessage.error({
        message: "登录失败：code 参数不能为空",
        duration: 2000,
        onClose: () => router.push("/")
      });
    } else {
      checkSession().then(user => {
        // bind user
        doLogin(user.id);
      }).catch(() => {
        doLogin(0);
      });
    }
    const doLogin = userId => {
      // 发送请求获取用户信息
      httpGet("/user/clogin/callback", {
        login_type: "wx",
        code: code,
        action: action,
        user_id: userId
      }).then(res => {
        if (res.data.token) {
          setUserToken(res.data.token);
        }
        if (res.data.username) {
          username.value = res.data.username;
          password.value = res.data.password;
          show.value = true;
          loading.value = false;
        } else {
          finishLogin();
        }
      }).catch(e => {
        ElMessageBox.alert(e.message, {
          confirmButtonText: '重新登录',
          type: "error",
          title: "登录失败",
          callback: () => {
            router.push("/login");
          }
        });
      });
    };
    const clipboard = ref(null);
    onMounted(() => {
      clipboard.value = new Clipboard('.copy-user-info');
      clipboard.value.on('success', () => {
        showMessageOK('复制成功！');
      });
      clipboard.value.on('error', () => {
        showMessageError('复制失败！');
      });
    });
    onUnmounted(() => {
      clipboard.value.destroy();
    });
    const finishLogin = () => {
      show.value = false;
      router.push(getRoute());
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_result = _resolveComponent("el-result");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "login-callback",
        "element-loading-text": "正在同步登录信息...",
        style: _normalizeStyle({
          height: winHeight.value + 'px'
        })
      }, [_createVNode(_component_el_dialog, {
        modelValue: show.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => show.value = $event),
        "close-on-click-modal": false,
        "show-close": false,
        style: {
          "width": "360px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_result, {
          icon: "success",
          title: "登录成功",
          style: {
            "--el-result-padding": "10px"
          }
        }, {
          "sub-title": _withCtx(() => [_createElementVNode("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("div", {
            class: "line"
          }, "您的初始账户信息如下：", -1)), _createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("span", null, "用户名：", -1)), _createTextVNode(_toDisplayString(username.value), 1)]), _createElementVNode("div", _hoisted_3, [_cache[2] || (_cache[2] = _createElementVNode("span", null, "密码：", -1)), _createTextVNode(_toDisplayString(password.value), 1)]), _cache[4] || (_cache[4] = _createElementVNode("div", {
            class: "line"
          }, "您后期也可以通过此账号和密码登录", -1))])]),
          extra: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            class: "copy-user-info",
            "data-clipboard-text": '用户名：' + username.value + ' 密码：' + password.value
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("复制")])),
            _: 1
          }, 8, ["data-clipboard-text"]), _createVNode(_component_el_button, {
            type: "danger",
            onClick: finishLogin
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("关闭")])),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])], 4)), [[_directive_loading, loading.value]]);
    };
  }
};